// import paths from '../../../../../config/paths';
// import config from '../../../../../config/config';

const PLYR_DEFAULTS = {
  speed: { selected: 1, options: [] },
  youtube: {
    noCookie: true,
  },
  // iconUrl:
  //   process.env.NODE_ENV === 'production'
  //     ? `${paths.publicPathProd}/${config.assetsDirName}/Images/plyr-icons.svg`
  //     : '/public/assets/Images/plyr-icons.svg',
};

export class Plyr {
  constructor(api, target, options = {}) {
    this.Api = api;
    this.target = target;
    this.options = { ...PLYR_DEFAULTS, ...options };
    this.player = null;
  }

  create = async () => {
    this.player = new this.Api(this.target, this.options);
    return this.player;
  };
}

export const getApi = async () => {
  const _ = await import(
    /* webpackChunkName: 'plyr' */ 'plyr/dist/plyr.polyfilled'
  );
  return _.default;
};
